module.exports = __webpack_public_path__ + "img/user.1393f806.png";